import type { SVGProps } from 'react';
export const IconSocialsTg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.9944 9.45542C24.7037 12.4419 23.4439 19.7 22.8043 23.0456C22.533 24.4632 21.9903 24.9358 21.4864 24.9925C20.3623 25.087 19.5095 24.2742 18.4241 23.5749C16.7186 22.4786 15.7495 21.7981 14.1021 20.7396C12.1833 19.511 13.4238 18.8306 14.5285 17.7343C14.8192 17.4508 19.7808 13.0467 19.8777 12.6498C19.8911 12.5896 19.8894 12.5272 19.8725 12.4679C19.8556 12.4087 19.8242 12.3543 19.7808 12.3095C19.6645 12.215 19.5095 12.2528 19.3738 12.2717C19.1994 12.3095 16.486 14.0674 11.1949 17.5453C10.4196 18.0556 9.72192 18.3202 9.10172 18.3013C8.40399 18.2824 7.08606 17.9233 6.09761 17.602C4.87659 17.2239 3.9269 17.016 4.00443 16.3545C4.04319 16.0142 4.52773 15.674 5.43865 15.3149C11.098 12.9144 14.858 11.3267 16.738 10.5706C22.126 8.37803 23.2307 8 23.9672 8C24.1222 8 24.4905 8.0378 24.7231 8.22682C24.9169 8.37803 24.975 8.58595 24.9944 8.73716C24.975 8.85057 25.0138 9.1908 24.9944 9.45542Z"
      fill="currentColor"
    />
  </svg>
);
